// extracted by mini-css-extract-plugin
export default {"FAQdiv":"FAQsection_FAQdiv__7rF+T","eachQuestion":"FAQsection_eachQuestion__i-mJy"};